import actions from './actions'
import featureValue from './metaData/featureValue'
export default {
  state: featureValue,
  actions
}
